export const SkeletonDashboard = () => {
  return (
    <div className="pr-[40px] pl-[10px] animate-pulse">
      {/* Header */}
      <div className="h-[60px] flex items-center justify-between">
        <div className="h-[30px] w-[200px] bg-gray-300 rounded" />
        <div className="h-[40px] w-[120px] bg-gray-300 rounded-full" />
      </div>

      {/* Subheading */}
      <div className="h-[20px] w-[100px] bg-gray-300 rounded mb-4" />

      {/* Loan Summary Section */}
      <div className="h-[300px] w-full bg-white rounded-[5px] px-[10px] mb-[15px] py-[20px]">
        <div className="flex items-center justify-center gap-[10px] mb-5">
          {[...Array(5)].map((_, i) => (
            <div
              key={i}
              className="w-[110px] h-[25px] bg-gray-200 rounded-full"
            />
          ))}
        </div>
        <div className="w-full flex items-center justify-center mb-6">
          <div className="w-[266px] h-[25px] bg-gray-200 rounded-full" />
        </div>
        <div className="flex justify-between items-center">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="w-[18%] h-[160px] bg-gray-200 rounded-lg" />
          ))}
        </div>
      </div>

      {/* Loan Portfolio Section */}
      <div className="h-[364px] w-full bg-white flex justify-between px-[10px] mb-[15px] py-[20px] rounded-[10px]">
        {/* Left Side Boxes */}
        <div className="w-[30%] flex flex-col gap-[10px]">
          <div className="h-[20px] w-[150px] bg-gray-300 rounded mb-[10px]" />
          <div className="h-[149px] bg-gray-200 rounded" />
          <div className="flex justify-between">
            <div className="h-[149px] w-[48%] bg-gray-200 rounded" />
            <div className="h-[149px] w-[48%] bg-gray-200 rounded" />
          </div>
        </div>

        {/* Middle Pie Chart Placeholder */}
        <div className="w-[38%] mt-[20px] h-full flex flex-col justify-around">
          <div className="w-full h-[220px] bg-gray-200 rounded-[30px]" />
          <div className="flex justify-center gap-4 mt-4">
            {[...Array(4)].map((_, i) => (
              <div key={i} className="flex items-center gap-2">
                <div className="h-[17px] w-[17px] rounded-full bg-gray-300" />
                <div className="h-[10px] w-[60px] bg-gray-200 rounded" />
              </div>
            ))}
          </div>
        </div>

        {/* Right Side Loan Pills */}
        <div className="w-[30%] h-full flex flex-col gap-[20px]">
          <div className="h-[20px] w-[120px] bg-gray-300 rounded mb-[5px]" />
          {[...Array(6)].map((_, i) => (
            <div key={i} className="h-[30px] w-full bg-gray-200 rounded-full" />
          ))}
        </div>
      </div>

      {/* Products & Borrowers Breakdown */}
      <div className="h-[370px] flex justify-between mb-[20px]">
        <div className="w-[49%] h-full bg-white p-[10px]">
          <div className="h-[20px] w-[180px] bg-gray-300 rounded mb-4" />
          <div className="w-full h-[300px] bg-gray-200 rounded-lg" />
        </div>
        <div className="w-[49%] h-full bg-white p-[10px]">
          <div className="h-[20px] w-[180px] bg-gray-300 rounded mb-4" />
          <div className="w-full h-[300px] bg-gray-200 rounded-lg" />
        </div>
      </div>

      {/* Loan Officer Performance */}
      <div className="h-[402px] w-full bg-white p-[10px] mb-[20px]">
        <div className="h-[20px] w-[220px] bg-gray-300 rounded mb-4" />
        <div className="w-full h-[330px] bg-gray-200 rounded-lg" />
      </div>
    </div>
  );
};
